import { platform } from 'constants'
import styled from 'styled-components/native'

import { TextInput } from 'widgets/TextInput'

type ContainerProps = {
  focused?: boolean
  disabled?: boolean
}

export const StyledTextInput = styled(TextInput)<ContainerProps>`
  flex: 1;
  height: 38px;
  border-radius: 20px;
  background-color: white;
  color: ${({ theme }) => theme.colors.black};
  font-size: ${({ theme }) => theme.fonts.sizes.sm + 1}px;

  ${platform.IS_IOS && 'padding-top: 8px; padding-bottom: 6px;'}
`
